<div class="container">
  <mat-card>
    <form [formGroup]="floatingRateForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap responsive-column gap-4percent">
          <mat-form-field class="flex-30">
            <mat-label>{{ 'labels.inputs.Floating Rate Name' | translate }}</mat-label>
            <input
              matInput
              required
              matTooltip="{{ 'tooltips.Unique name for the floating rate scheme' | translate }}"
              formControlName="name"
            />
            @if (floatingRateForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Floating Rate Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <div class="checkbox-wrapper flex-30">
            <mat-checkbox
              formControlName="isBaseLendingRate"
              matTooltip="{{ 'tooltips.Base lending rate for the organisation' | translate }}"
              class="checkbox"
              labelPosition="before"
              >{{ 'labels.inputs.Is Base Lending Rate' | translate }}?</mat-checkbox
            >
          </div>

          <div class="checkbox-wrapper flex-30">
            <mat-checkbox
              formControlName="isActive"
              matTooltip="{{ 'tooltips.Floating rate scheme to be activated' | translate }}"
              class="checkbox"
              labelPosition="before"
              >{{ 'labels.inputs.Active' | translate }}</mat-checkbox
            >
          </div>
        </div>

        <br />

        <mat-divider [inset]="true"></mat-divider>

        <br />

        <div class="layout-row-wrap gap-70percent m-b-10 layout-lt-md-column">
          <p class="mat-title flex-25">
            {{ 'labels.inputs.Floating Rate Periods' | translate }}
            <i
              class="fas fa-question"
              matTooltip="{{ 'tooltips.Floating interest rate and start date' | translate }}"
            ></i>
          </p>

          <button mat-mini-fab type="button" color="primary" (click)="addFloatingRatePeriod()">
            <fa-icon icon="plus"></fa-icon>
          </button>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="fromDate">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="{{ 'tooltips.Interest effective from date' | translate }}"
              mat-sort-header
            >
              {{ 'labels.inputs.From Date' | translate }}
            </th>
            <td mat-cell *matCellDef="let floatingRatePeriod">{{ floatingRatePeriod.fromDate | dateFormat }}</td>
          </ng-container>

          <ng-container matColumnDef="interestRate">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="{{ 'tooltips.Annualised Interest rate' | translate }}"
              mat-sort-header
            >
              {{ 'labels.inputs.Interest Rate' | translate }}
            </th>
            <td mat-cell *matCellDef="let floatingRatePeriod">{{ floatingRatePeriod.interestRate | formatNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="isDifferential">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="{{ 'tooltips.Interest rate mentioned is added to base lending rate' | translate }}"
              mat-sort-header
            >
              {{ 'labels.inputs.Is Differential' | translate }}?
            </th>
            <td mat-cell *matCellDef="let floatingRate">
              @if (floatingRate.isDifferentialToBaseLendingRate) {
                <fa-icon
                  icon="check-circle"
                  size="lg"
                  class="is-differential"
                  matTooltip="{{ 'tooltips.Yes' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
              @if (!floatingRate.isDifferentialToBaseLendingRate) {
                <fa-icon
                  icon="times-circle"
                  size="lg"
                  class="not-is-differential"
                  matTooltip="{{ 'tooltips.No' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
            <td mat-cell *matCellDef="let floatingRatePeriod" class="gap-15percent">
              <button
                type="button"
                class="flex-8"
                color="primary"
                mat-icon-button
                matTooltip="{{ 'tooltips.Edit Period' | translate }}"
                matTooltipPosition="left"
                (click)="editFloatingRatePeriod(floatingRatePeriod)"
              >
                <fa-icon icon="edit" size="lg"></fa-icon>
              </button>
              <button
                type="button"
                class="flex-8"
                color="warn"
                mat-icon-button
                matTooltip="{{ 'tooltips.Remove Period' | translate }}"
                matTooltipPosition="right"
                (click)="deleteFloatingRatePeriod(floatingRatePeriod)"
              >
                <fa-icon icon="trash" size="lg"></fa-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          type="submit"
          color="primary"
          [disabled]="!floatingRateForm.valid"
          *LOSxHasPermission="'CREATE_FLOATINGRATE'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
